import React, { useMemo, useRef, useState, useEffect } from 'react';
import 'animate.css';
import './Home.css';
import { useNavigate } from 'react-router-dom';
import perfumeBanner from '../assets/images/perfumes-banner.png';

function Home() {
  const navigate = useNavigate();
  const handleExploreClick = () => navigate('/products');

  const pueblos = [
    'Dzidzantún',
    'Dzilam de Bravo',
    'Dzilam González',
    'Yobaín',
    'Cansahcab',
    'Tizimín',
    'Mérida',
    'Progreso',
    'Telchac Pueblo',
    'Motul',
    'Baca',
    'Conkal',
  ];

  const [puebloSeleccionado, setPuebloSeleccionado] = useState(pueblos[0]);
  const waNumber = '529994982533';

  const whatsappUrl = useMemo(() => {
    const msg = encodeURIComponent(
      `Hola Smashes Store 👋 ¿Me confirmas entrega a ${puebloSeleccionado} y el costo de envío?`
    );
    return `https://wa.me/${waNumber}?text=${msg}`;
  }, [puebloSeleccionado]);

  // ===== Animación on-scroll para la lista =====
  const deliveryRef = useRef(null);
  const [animateList, setAnimateList] = useState(false);

  useEffect(() => {
    const el = deliveryRef.current;
    if (!el) return;

    const obs = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setAnimateList(true);
          obs.disconnect(); // ✅ solo una vez
        }
      },
      { threshold: 0.25 }
    );

    obs.observe(el);
    return () => obs.disconnect();
  }, []);

  return (
    <div className="home-container">
      <div className="overlay">
        <div className="home-content">
          <h1>SMASHES STORE</h1>
          <h2>EXCLUSIVIDAD Y ELEGANCIA</h2>

          <p>
            Perfumes 100% originales y completos <br /><br />
            Elegancia, autenticidad y presencia en cada fragancia
          </p>

          <img src={perfumeBanner} alt="Perfume Banner" />

          <div className="button-group">
            <button className="gradient-button" onClick={handleExploreClick}>
              Explorar perfumes
            </button>
          </div>

          <p className="disclaimer">
            ✔️ Perfumes originales | 🔒 Compra segura | 🚚 Entregas rápidas
          </p>

          <section className="delivery-section" ref={deliveryRef}>
            <div className="delivery-card">
              <h3>Entrega a tu zona</h3>
              <p className="delivery-subtitle">
                Selecciona tu pueblo para confirmar cobertura y costo de envío.
              </p>
              <p className="delivery-line">
                🚚 Entrega local • 💬 Respuesta rápida • ✅ Perfumes completos
              </p>

              <ul className="pueblos-list">
                {pueblos.map((pueblo, idx) => {
                  const anim =
                    idx % 2 === 0
                      ? 'animate__bounceInLeft'
                      : 'animate__bounceInRight';

                  return (
                    <li key={pueblo}>
                      <button
                        type="button"
                        className={[
                          'pueblo-row',
                          pueblo === puebloSeleccionado ? 'active' : '',
                          animateList ? `animate__animated ${anim}` : 'pueblo-hidden',
                        ].join(' ')}
                        style={{
                          animationDelay: animateList ? `${idx * 0.12}s` : undefined,
                        }}
                        onClick={() => setPuebloSeleccionado(pueblo)}
                      >
                        <span className="pueblo-pin">📍</span>
                        <span className="pueblo-name">{pueblo}</span>
                      </button>
                    </li>
                  );
                })}
              </ul>

              <a
                className="delivery-cta"
                href={whatsappUrl}
                target="_blank"
                rel="noopener noreferrer"
              >
                Confirmar entrega en {puebloSeleccionado}
              </a>

              <p className="delivery-mini">
                Tip: mándanos tu ubicación o el nombre de tu pueblo para confirmarte la entrega.
              </p>
            </div>
          </section>
        </div>
      </div>
    </div>
  );
}

export default Home;
